export default "__VITE_ASSET__2556fb08__"